import { computed, ref, toValue, type MaybeRefOrGetter } from 'vue'

export function useNormalizedFilter<T>(
  source: MaybeRefOrGetter<T[]>,
  toSearchText: (item: T) => string,
) {

  const searchQuery = ref('')
  const filteredItems = computed(() => {
    const normalizedQuery = normalizeText(searchQuery.value)
    const items = toValue(source) ?? []

    if (!normalizedQuery) {
      return items
    }

    return items.filter((item) =>
      normalizeText(toSearchText(item)).includes(normalizedQuery),
    )
  })

  function setSearchQuery(query: string): void {
    searchQuery.value = query
  }

  function clearSearchQuery(): void {
    searchQuery.value = ''
  }

  return {
    searchQuery,
    filteredItems,
    setSearchQuery,
    clearSearchQuery,
  }
}

function normalizeText(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
}



